import React, {useState} from "react";
import {resetMenu} from "../redux/slices/menuSlice";
import {useDispatch} from "react-redux";
import { Table, Space, Pagination, Modal, Checkbox, Button as ButtonAntd, message } from 'antd';
import EntityApi from "../api/EntityApi";
import {ExportOutlined, SearchOutlined} from '@ant-design/icons';
import {Link} from "react-router-dom";
import Input from "../components/element/Input";
import Button from "../components/element/Button";
import useAuth from "../hooks/useAuth";
import RequestApi from "../api/RequestApi";

const TestingPage = () => {

    const { roles }  = useAuth();
    const dispatch = useDispatch();
    const [dataSource, setDataSource] = useState([]);
    const [inputSearchClient, setInputSearchClient] = useState('');
    const [inputSearchCompany, setInputSearchCompany] = useState('');
    const [inputSearchProduct, setInputSearchProduct] = useState('');
    const [inputSearchTesting, setInputSearchTesting] = useState('');
    const [sortField, setSortField] = useState('startDt');
    const [sortOrder, setSortOrder] = useState('desc');
    const [isLoading, setIsLoading] = useState(false);
    const [isFilter, setIsFilter] = useState(false);
    const [isReload, setIsReload] = useState(false);
    const [total, setTotal] = React.useState(0);
    const [page, setPage] = React.useState(1);
    const [pageSize, setPageSize] = React.useState(10);
    const [selectItems, setSelectItems] = React.useState([]);
    const [selectCount, setSelectCount] = React.useState(0);
    const [isLoadingExport, setIsLoadingExport] = useState(false);
    const [isSelectAll, setIsSelectAll] = React.useState(false);
    // detail
    const [isOpenDetail, setOpenDetail] = React.useState(false);
    const [isLoadingDetail, setLoadingDetail] = React.useState(false);
    const [resultFinish, setResultFinish] = React.useState(null);
    const [isSendResetLocker, setSendResetLocker] = React.useState(false);

    const handleIsFilter = () => {
        setIsFilter(false);
        if (inputSearchClient.length > 0 || inputSearchProduct.length > 0) {
            setIsFilter(true);
        }
    }

    const handleResetFilter = () => {
        setInputSearchClient('');
        setInputSearchProduct('');
        setIsReload(!isReload);
    }

    const handleTableChange = (pagination, filters, sorter) => {
        if (sorter.hasOwnProperty("column")) {
            if (sorter.field !== undefined) {
                setSortField(sorter.field);
            } else {
                setSortField('id');
            }
            if (sorter.order === 'ascend') {
                setSortOrder('asc');
            }
            if (sorter.order === 'descend') {
                setSortOrder('desc');
            }
        } else {
            setSortField('id');
            setSortOrder('desc');
        }
        setIsReload(!isReload);
    }

    const handleSearchClient = (selectedKeys, confirm) => {
        confirm();
        setIsReload(!isReload);
    }

    const handleResetClient = (confirm) => {
        setInputSearchClient('');
        confirm();
        setIsReload(!isReload);
    };

    const handleResetCompany = (confirm) => {
        setInputSearchCompany('');
        confirm();
        setIsReload(!isReload);
    };

    const handleSearchProduct = (selectedKeys, confirm) => {
        confirm();
        setIsReload(!isReload);
    };
    const handleResetProduct = (confirm) => {
        setInputSearchProduct('');
        confirm();
        setIsReload(!isReload);
    };

    const handleSearchTesting = (selectedKeys, confirm) => {
        confirm();
        setIsReload(!isReload);
    };
    const handleResetTesting = (confirm) => {
        setInputSearchTesting('');
        confirm();
        setIsReload(!isReload);
    };

    const onPaginate = (p) => {
        setPage(p);
        setIsReload(!isReload);
    }

    const onOpenDetail = (testingId) => {
        setOpenDetail(true);
        setLoadingDetail(true);
        setSendResetLocker(false);
        EntityApi.post('private/testing-result',  testingId, {}).then((data) => {
            setLoadingDetail(false);
            if (data.status === EntityApi.STATUS_SUCCESS && data.content.item !== undefined) {
                setResultFinish(data.content.item)
            }
        }).catch(() => {
            setLoadingDetail(false);
        });
    }

    const onResetLocker = (testingId, resultId) => {
        if (testingId > 0 && resultId > 0) {
            EntityApi.post('private/testing/reset-locker',  testingId, {
                result_id: resultId
            }).then((data) => {
                if (data.status === EntityApi.STATUS_SUCCESS) {
                    setSendResetLocker(true);
                }
            });
        }
    }

    const getColumnSearchClient = () => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
            <div className={'p-2'}>
                <Input type='text' onChange={(value) => setInputSearchClient(value)} value={inputSearchClient} placeholder={'Номер телефона или имя'} />
                <Space className={'pt-2'}>
                    <Button text={'Найти'} type={'primary'} onClick={() => handleSearchClient(selectedKeys, confirm)}/>
                    <Button text={'Сбросить'} type={'default'} onClick={() => confirm && handleResetClient(confirm)}/>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? '#1677ff' : undefined,
                }}
            />
        )
    })

    const getColumnSearchCompany = () => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
            <div className={'p-2'}>
                <Input type='text' onChange={(value) => setInputSearchCompany(value)} value={inputSearchCompany} placeholder={'Название или ИНН'} />
                <Space className={'pt-2'}>
                    <Button text={'Найти'} type={'primary'} onClick={() => handleSearchClient(selectedKeys, confirm)}/>
                    <Button text={'Сбросить'} type={'default'} onClick={() => confirm && handleResetCompany(confirm)}/>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? '#1677ff' : undefined,
                }}
            />
        )
    })

    const getColumnSearchProduct = () => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
            <div className={'p-2'}>
                <Input type='text' onChange={(value) => setInputSearchProduct(value)} value={inputSearchProduct} placeholder={'Код или название'} />
                <Space className={'pt-2'}>
                    <Button text={'Найти'} type={'primary'} onClick={() => handleSearchProduct(selectedKeys, confirm)}/>
                    <Button text={'Сбросить'} type={'default'} onClick={() => confirm && handleResetProduct(confirm)}/>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? '#1677ff' : undefined,
                }}
            />
        )
    })

    const getColumnSearchTesting = () => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
            <div className={'p-2'}>
                <Input type='text' onChange={(value) => setInputSearchTesting(value)} value={inputSearchTesting} placeholder={'Название'} />
                <Space className={'pt-2'}>
                    <Button text={'Найти'} type={'primary'} onClick={() => handleSearchTesting(selectedKeys, confirm)}/>
                    <Button text={'Сбросить'} type={'default'} onClick={() => confirm && handleResetTesting(confirm)}/>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? '#1677ff' : undefined,
                }}
            />
        )
    })

    const onSelectItem = (checked, id) => {
        let items = selectItems;
        if (checked) {
            if (items.indexOf(id) === -1) {
                items.push(id);
            }
        } else {
            if (items.indexOf(id) !== -1) {
                items.splice(items.indexOf(id), 1);
            }
        }
        console.log(items);
        setSelectItems(items);
        setSelectCount(items.length);
    }

    const onResetSelectItems = () => {
        setSelectItems([]);
        setSelectCount(0);
        setIsReload(!isReload);
    }

    const onExport = () => {
        setIsLoadingExport(true);
        let filterExport = {
            client: inputSearchClient,
            product: inputSearchProduct,
            testing: inputSearchTesting,
            company: inputSearchCompany,
        }
        if (selectItems.length > 0) {
            filterExport = {ids: selectItems}
        }
        RequestApi.post('private/testing-results', {
            filter: filterExport,
            sort: {
                ['id']: 'desc'
            },
            size: 100000000,
            page: 1,
            is_export: true
        }).then((data) => {
            setIsLoadingExport(false);
            if (data.status === RequestApi.STATUS_SUCCESS) {
                window.open(data.content.item.url, '_blank');
            } else {
                message.error('Ошибка выгрузки');
            }
        }).catch((error) => {
            setIsLoadingExport(false);
            message.error('Ошибка сервера');
        });
    }

    const columns = [];
    columns.push({
        title: '',
        width: 50,
        render: (item) => <Checkbox checked={selectItems.includes(item.id)} onChange={(e) => onSelectItem(e.target.checked, item.id)}></Checkbox>
    })
    columns.push({
        title: 'Информация о тестировании',
        responsive: ['xs'],
        ...getColumnSearchProduct(),
        render: (item) => {
            return <>
                <div>{item.testing}</div>
                <div><span className={'font-bold'}>Дата: </span>{item.finishDt} {item.dt_time}</div>
                <div><span className={'font-bold'}>Курс: </span>{item.title}</div>
                {
                    (roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MANAGER')) &&
                    <div>
                        <div><span className={'font-bold'}>ФИО: </span> <Link to={'/cabinet/users/' + item.clientId}>{item.client}</Link></div>
                        <div><span className={'font-bold'}>Телефон: </span> <Link to={'/cabinet/users/' + item.clientId}>{item.login}</Link></div>
                        <div><span className={'font-bold'}>Компания: </span> {item.company}</div>
                    </div>
                }
                <div><span className={'font-bold'}>Результат: </span>{
                    item.result ? <span style={{color: 'green'}}>Успешно</span> :
                        <span style={{color: 'red'}}>Не успешно</span>
                }</div>
                <div className={'mt-2'}>
                    <Button onClick={() => onOpenDetail(item.id)} text={'Отчет'} type={'defaultSmall'}/>
                </div>
            </>
        }
    });
    columns.push({
        title: 'Дата',
        width: 150,
        dataIndex: 'finishDt',
        responsive: ['md'],
        sorter: true,
        render: (finishDt, data) => <span>{finishDt}<br/>{data.dt_time}</span>
    });
    if (roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MANAGER')) {
        columns.push({
            title: 'ФИО',
            width: 300,
            dataIndex: 'client',
            responsive: ['md'],
            ...getColumnSearchClient(),
            render: (client, data) => <Link to={'/cabinet/users/' + data.clientId}>{data.client}</Link>
        });
        columns.push({
            title: 'Телефон',
            width: 200,
            dataIndex: 'login',
            responsive: ['md'],
            ...getColumnSearchClient(),
            render: (login, data) => <Link to={'/cabinet/users/' + data.clientId}>{data.login}</Link>
        });
        columns.push({
            title: 'Компания',
            dataIndex: 'company',
            responsive: ['md'],
            ...getColumnSearchCompany(),
        });
    }
    columns.push({
        title: 'Курс',
        dataIndex: 'title',
        responsive: ['md'],
        ...getColumnSearchProduct(),
        render: (title, data) => data.course_id ? <Link to={'/cabinet/catalog/course/' + data.course_id}>{title}</Link> : <span>{title}</span>
    });
    columns.push({
        title: 'Тестирование',
        //width: 200,
        dataIndex: 'testing',
        responsive: ['md'],
        ...getColumnSearchTesting(),
        render: (testing, data) => data.course_id ? <Link to={'/cabinet/catalog/course/' + data.course_id}>{testing}</Link> : <span>{testing}</span>
    });
    columns.push({
        title: 'Результат',
        width: 150,
        dataIndex: 'result',
        responsive: ['md'],
        render: (result, data) => <div>
            {
                result ? <span style={{color: 'green'}}>Успешно</span> : <span style={{color: 'red'}}>Не успешно</span>
            }
            <div className={'mt-2'}>
                <Button onClick={() => onOpenDetail(data.id)} text={'Отчет'} type={'defaultSmall'}/>
            </div>
        </div>
    });


    const getList = () => {
        setIsLoading(true);
        handleIsFilter();
        EntityApi.getBy('private/testing-results', {
            filter: {
                client: inputSearchClient,
                product: inputSearchProduct,
                testing: inputSearchTesting,
                company: inputSearchCompany,
            },
            sort: {
                [sortField]: sortOrder
            },
            size: pageSize,
            page: page
        }).then((data) => {
            setIsLoading(false);
            if (data.status === EntityApi.STATUS_SUCCESS) {
                let items = [];
                if (data.content.items) {
                    data.content.items.forEach((content) => {

                        let item = {
                            key: content.id,
                            id: content.id,
                            finishDt: content.finishDt,
                            dt_time: content.dt_time,
                            clientId:  content.client.id,
                            login:  content.client.login,
                            client: content.client.surname + ' ' +  content.client.name + ' ' + content.client.fathername,
                            company: content.client.company,
                            title: content.title,
                            course_id: content.course_id,
                            testing: content.testing.title,
                            result: content.testing.is_success

                        }
                        items.push(item);
                    });
                }
                setDataSource(items);
                setTotal(data.payload.total);
                setPage(data.payload.currentPage);
            }
        });
    }

    React.useEffect(() => {
        dispatch(resetMenu());
        getList();
    }, [isReload])

    return <>
        <div className="flex items-center justify-between py-5 lg:py-6">
            <div className="flex items-center space-x-1">
                <h2 className="line-clamp-1 text-xl font-medium text-slate-700 dark:text-navy-50 lg:text-2xl">
                    Результаты тестирований
                </h2>
            </div>
        </div>
        <div className="card px-4 pb-4">
            <div className="my-3 flex h-8 items-center justify-between">
                <h2 className="line-clamp-1 font-medium tracking-wide text-slate-700 dark:text-navy-100 lg:text-base">
                    Список результатов
                </h2>
                <div className={'flex items-center'}>
                    {
                        selectCount > 0 &&
                        <div className={'pr-3'}><span className={'underline cursor-pointer'} onClick={onResetSelectItems}>Сбросить</span> Выбрано: {selectCount}</div>
                    }
                    <ButtonAntd disabled={isLoadingExport} onClick={onExport} type={'primary'}><ExportOutlined/> Экспорт</ButtonAntd>
                </div>
            </div>
            <Table loading={isLoading} onChange={handleTableChange} columns={columns} dataSource={dataSource} pagination={false}></Table>
            <div className={'pt-3'}>
                <Pagination defaultCurrent={page} pageSize={pageSize} showSizeChanger={true} onShowSizeChange={(current, size) => setPageSize(size)} onChange={onPaginate} total={total}/>
            </div>
        </div>
        <Modal open={isOpenDetail} width={'90%'} onCancel={() => setOpenDetail(false)}
               onOk={() => setOpenDetail(false)}>
            {
                isLoadingDetail &&
                <div style={{top: '0px', left: '0px'}} className="app-preloader absolute opacity-50 z-50 grid h-full w-full place-content-center bg-slate-50 dark:bg-navy-900">
                    <div className="app-preloader-inner relative inline-block h-48 w-48"></div>
                </div>
            }
            {
                resultFinish && !isLoadingDetail &&
                <div>
                    <div className={'flex mob-block'}>
                        <div className={'w-6/12 mob-w-full'}>
                            <div className={"mt-3 font-bold"}>{resultFinish.testing}</div>
                            <div className={"mt-3 font-bold"}>{resultFinish.client.fullname}</div>
                            <div className={"font-bold"}>Результаты тестирования</div>
                            <div>Дата прохождения тестирования: {resultFinish.dt}</div>
                            <div className={'flex'}>
                                <div className={'mr-1'}>Результат теста:</div>
                                {resultFinish.is_success ?
                                    <div className={'flex'}>
                                        <div style={{color: 'green', width: '150px'}}> Успешно</div>
                                        {
                                            (roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MANAGER')) && resultFinish.is_exam && !isSendResetLocker &&
                                            <Button type={'successSmall'} text={'Предоставить еще попытку'}
                                                    onClick={() => onResetLocker(resultFinish.testing_id, resultFinish.result_id)}/>
                                        }
                                        {
                                            isSendResetLocker &&
                                            <span style={{color: 'green'}}>Попытка предоставлена</span>
                                        }
                                    </div>

                                    :
                                    <div className={'flex'}>
                                        <div style={{color: 'red', width: '150px'}}> Не успешно</div>
                                        {
                                            (roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MANAGER')) && resultFinish.is_exam && !isSendResetLocker &&
                                            <Button type={'successSmall'} text={'Предоставить еще попытку'}
                                                    onClick={() => onResetLocker(resultFinish.testing_id, resultFinish.result_id)}/>
                                        }
                                        {
                                            isSendResetLocker &&
                                            <span style={{color: 'green'}}>Попытка предоставлена</span>
                                        }
                                    </div>
                                }
                            </div>
                            {
                                ((resultFinish.is_exam && (roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MANAGER')) || !resultFinish.is_exam || resultFinish.is_success)) &&
                                <div>Процент правильных ответов {resultFinish.progress_prc}% вопросов
                                    ({resultFinish.answers_success} / {resultFinish.questions_total})
                                </div>
                            }
                            {
                                (resultFinish.is_grade && resultFinish.grades) &&
                                <div>
                                    Оценка: {
                                    resultFinish.grades && resultFinish.answers_success  >= resultFinish.grades.grade5 ? <span style={{color: 'green'}}>Отлично</span> :
                                        resultFinish.grades && resultFinish.answers_success  >= resultFinish.grades.grade4 ? <span style={{color: 'green'}}>Хорошо</span> :
                                            resultFinish.grades && resultFinish.answers_success  >= resultFinish.grades.grade3 ? <span style={{color: 'blue'}}>Удовлетворительно</span> :
                                                <span style={{color: 'red'}}>Не удовлетворительно</span>
                                }
                                </div>
                            }
                            <div>Затраченное время: {resultFinish.time}</div>
                        </div>
                        <div className={'w-6/12 mob-w-full pt-3'}>
                            {
                                resultFinish.is_exam && resultFinish.is_success && <div dangerouslySetInnerHTML={{ __html: resultFinish.information }}></div>
                            }
                        </div>
                    </div>
                    {
                        ((resultFinish.is_exam && (roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MANAGER')) || !resultFinish.is_exam || resultFinish.is_success)) &&
                        <div className={'mt-3'}>
                            <div
                                className={'is-scrollbar-hidden min-w-full overflow-x-auto rounded-lg border border-slate-200 dark:border-navy-500'}>
                                <table className="w-full text-left exam-testing__table-result">
                                    <thead>
                                    <tr>
                                        <th className="whitespace-nowrap border border-t-0 border-l-0 border-slate-200 px-3 py-3 font-semibold uppercase text-slate-800 dark:border-navy-500 dark:text-navy-100 lg:px-5">
                                            #
                                        </th>
                                        <th className="border border-t-0 border-slate-200 px-3 py-3 font-semibold uppercase text-slate-800 dark:border-navy-500 dark:text-navy-100 lg:px-5">
                                            Вопрос
                                        </th>
                                        <th className="border border-t-0 border-slate-200 px-3 py-3 font-semibold uppercase text-slate-800 dark:border-navy-500 dark:text-navy-100 lg:px-5" style={{minWidth: '210px'}}>
                                            Правильный ответы
                                        </th>
                                        <th className="border border-t-0 border-slate-200 px-3 py-3 font-semibold uppercase text-slate-800 dark:border-navy-500 dark:text-navy-100 lg:px-5">
                                            Ответы
                                        </th>
                                        <th className="whitespace-nowrap border border-t-0 border-slate-200 px-3 py-3 font-semibold uppercase text-slate-800 dark:border-navy-500 dark:text-navy-100 lg:px-5">
                                            Результат
                                        </th>
                                        <th className="whitespace-nowrap border border-t-0 border-r-0 border-slate-200 px-3 py-3 font-semibold uppercase text-slate-800 dark:border-navy-500 dark:text-navy-100 lg:px-5">
                                            Время
                                        </th>
                                        {
                                            resultFinish.is_show_info &&
                                            <th style={{minWidth: '210px'}} className="border border-t-0 border-slate-200 px-3 py-3 font-semibold uppercase text-slate-800 dark:border-navy-500 dark:text-navy-100 lg:px-5">
                                                Нормативная документация
                                            </th>
                                        }
                                    </tr>
                                    </thead>
                                <tbody>
                                {
                                    resultFinish.answers.map((answer, index) => {
                                        return <tr key={index}>
                                            <td className="whitespace-nowrap border border-l-0 border-slate-200 px-3 py-3 dark:border-navy-500 lg:px-5 mob-grey">
                                                <span className={'desktop-hidden font-bold'}>Вопрос #</span>{index + 1}
                                            </td>
                                            <td className="border border-slate-200 px-3 py-3 dark:border-navy-500 lg:px-5">
                                                <div className={'desktop-hidden font-bold'}>Вопрос: </div> {answer.text}
                                            </td>
                                            <td className="border border-slate-200 px-3 py-3 dark:border-navy-500 lg:px-5" style={{minWidth: '210px'}}>
                                                <div className={'desktop-hidden font-bold'}>Правильные ответы: </div>{
                                                    answer.correct_answer && answer.correct_answer.map((correctAnswer, key) =>
                                                        <div key={key}>{correctAnswer}</div>)
                                                }
                                            </td>
                                            <td className="border border-slate-200 px-3 py-3 dark:border-navy-500 lg:px-5">
                                                <div className={'desktop-hidden font-bold'}>Ответы: </div>{
                                                    answer.user_answer && answer.user_answer.map((userAnswer, key) =>
                                                        <div key={key}>{userAnswer}</div>)
                                                }
                                            </td>
                                            <td className="whitespace-nowrap border border-slate-200 px-3 py-3 dark:border-navy-500 lg:px-5">
                                                <span className={'desktop-hidden font-bold'}>Результат: </span>{answer.is_success ?
                                                <span style={{color: 'green'}}>Успешно</span> :
                                                <span style={{color: 'red'}}>Не успешно</span>}
                                            </td>
                                            <td className="whitespace-nowrap border border-r-0 border-slate-200 px-3 py-3 dark:border-navy-500 lg:px-5">
                                                <span className={'desktop-hidden font-bold'}>Затраченное время: </span>{answer.time}
                                            </td>
                                            {
                                                resultFinish.is_show_info &&
                                                <td className="border border-slate-200 px-3 py-3 dark:border-navy-500 lg:px-5">
                                                    <div className={'desktop-hidden font-bold'}>Нормативная документация:</div>
                                                    <div>{answer.info}</div>
                                                </td>
                                            }
                                        </tr>
                                    })
                                }

                                </tbody>
                            </table>
                            </div>
                        </div>
                    }
                </div>
            }
        </Modal>
    </>
}

export default TestingPage;
